import ToastPopup from '../../../HelperClasses/AppLoaderClasses/ToastPopup';
import networkService from '../../../Network/NetworkManager';
const APPURL = require('../../../Constants/URLConstants');

const submitExtension = async ({
  form_data,
  setIsLoading,
  onSuccess,
  isEdit,
  id,
}) => {
  try {
    setIsLoading(true);
    let form_data_copy = {...form_data};
    Object.keys(form_data_copy).forEach(key => {
      if (form_data_copy[key] === null || form_data_copy[key] === '') {
        delete form_data_copy[key];
      }
    });

    //
    const responseJson = isEdit
      ? await networkService.networkCall(
          APPURL.URLPaths.extension + `/${id}`,
          'PATCH',
          JSON.stringify({extension: form_data_copy}),
        )
      : await networkService.networkCall(
          APPURL.URLPaths.extension,
          'post',
          JSON.stringify({extension: form_data_copy}),
        );

    setIsLoading(false);
    if (responseJson.status) {
      onSuccess();
    } else {
      ToastPopup({type: 'error', message: 'Something went wrong'});
    }
  } catch (error) {
    setIsLoading(false);
  }
};

export default submitExtension;
